import {ResponseLettersType} from 'entities'
import {getLetters} from 'src/lib/getLetters'
import {APIServiceLetters} from './entities'
import {GetMessagesParamsType} from '../translates/entities'

class LocalApiServiceLetters implements APIServiceLetters {
  public init() {
  }

  public async getLetters(params: GetMessagesParamsType): Promise<ResponseLettersType> {
    return Promise.resolve(getLetters(params.lang));
  }
}

export const localApiServiceLetters = new LocalApiServiceLetters()
